import React from 'react';
import { Container, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './TermsOfServiceSection.css';

const sections = [
  {
    title: 'Acceptance of Terms',
    content: (
      <>
        <Typography gutterBottom>
          By using the Virves Software Solutions website and services, you agree to these Terms of Service. If you do not accept these terms, please refrain from using our site. We may update these terms at any time, and your continued use of the site constitutes acceptance of any changes.
        </Typography>
      </>
    )
  },
  {
    title: 'Intellectual Property',
    content: (
      <>
        <Typography gutterBottom>
          All content on this site, including images, text, logos, and designs, are the property of Virves Software Solutions or its licensors and are protected by copyright and trademark laws. You may not use, reproduce, or distribute any content without our written permission.
        </Typography>
      </>
    )
  },
  {
    title: 'Account and Registration',
    content: (
      <>
        <Typography gutterBottom>
          You are responsible for maintaining the confidentiality of your account and password. You agree to provide accurate and current information and to update it as necessary. Virves Software Solutions is not liable for any loss or damage resulting from your failure to protect your account information.
        </Typography>
      </>
    )
  },
  {
    title: 'Refund & Return Policy',
    content: (
      <>
        <Typography gutterBottom>
          Orders are processed upon receiving confirmation. Goods once sold cannot be returned or exchanged except as required by law. Any claims for damage or shortages must be reported immediately upon receipt. Refunds for advance payments are processed upon request if no service or product is delivered.
        </Typography>
      </>
    )
  },
  {
    title: 'Product Description & Availability',
    content: (
      <>
        <Typography gutterBottom>
          We strive to provide accurate product and service descriptions. However, we do not warrant that descriptions or other content are error-free. If a product or service is not as described, your sole remedy is to contact us for resolution. Product and service availability may change, and we will notify you if an order cannot be fulfilled.
        </Typography>
      </>
    )
  },
  {
    title: 'Order Cancellation',
    content: (
      <>
        <Typography gutterBottom>
          Virves Software Solutions reserves the right to refuse or cancel any order for any reason, including limitations on quantities, errors in product or pricing information, or issues identified by our fraud prevention team. If your order is cancelled after payment, a refund will be processed to your original payment method.
        </Typography>
      </>
    )
  },
  {
    title: 'Payment & Card Details',
    content: (
      <>
        <Typography gutterBottom>
          You agree to provide valid and accurate payment information. We do not store or share your card details except as required for payment processing or by law. Virves Software Solutions is not liable for any unauthorized use of your payment information.
        </Typography>
      </>
    )
  },
  {
    title: 'Fraudulent/Declined Transactions',
    content: (
      <>
        <Typography gutterBottom>
          We reserve the right to recover costs and take legal action in cases of fraudulent use of our site or services. Orders may be declined or cancelled if fraud is suspected.
        </Typography>
      </>
    )
  },
  {
    title: 'Eligibility',
    content: (
      <>
        <Typography gutterBottom>
          By using our site, you represent that you are legally eligible to enter into binding agreements. If you are not eligible, please do not use our services.
        </Typography>
      </>
    )
  },
  {
    title: 'User Responsibilities',
    content: (
      <>
        <Typography gutterBottom>
          You agree to use our services for lawful purposes only and to provide true and accurate information. You are responsible for any activity under your account and for complying with all applicable laws and regulations.
        </Typography>
      </>
    )
  },
  {
    title: 'Payment Services',
    content: (
      <>
        <Typography gutterBottom>
          Virves Software Solutions is not liable for any loss or damage arising from declined payment authorizations or exceeding preset limits. All payments are subject to verification and approval by our payment partners.
        </Typography>
      </>
    )
  }
];

const TermsOfServiceSection = () => (
  <Box className="terms-of-service-section-root">
    <Container maxWidth="md">
      <Typography variant="h2" align="center" gutterBottom className="terms-of-service-title">
        Terms of Service
      </Typography>
      {sections.map((section, idx) => (
        <Accordion key={idx} className="terms-accordion">
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className="terms-accordion-summary">
            <Typography className="terms-accordion-summary">{section.title}</Typography>
          </AccordionSummary>
          <AccordionDetails className="terms-accordion-details">
            {section.content}
          </AccordionDetails>
        </Accordion>
      ))}
      <Box sx={{ mt: 6 }}>
        <Typography variant="h6" className="terms-contact-title">
          Contact Us
        </Typography>
        <Typography className="terms-contact-text">
          If you have any questions about these Terms of Service, you can contact us at <a href="mailto:support@virvessoftware.com">support@virvessoftware.com</a>.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default TermsOfServiceSection; 